var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1370,
    height: 706,
    viewBox: "0 0 1370 706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.5 211L133.395 211C132.494 211 131.631 211.358 130.994 211.994C130.358 212.631 130 213.494 130 214.395L130 236.5C130 238.985 127.985 241 125.5 241L104.5 241C102.015 241 100 238.985 100 236.5L100 215.5C100 213.015 102.015 211 104.5 211L126.605 211C127.505 211 128.369 210.642 129.006 210.006C129.642 209.369 130 208.505 130 207.605L130 185.5C130 183.015 132.015 181 134.5 181L215.5 181C217.985 181 220 183.015 220 185.5L220 206.5C220 208.985 217.985 211 215.5 211Z",
    fill: "url(#paint0_linear_1_169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 271C187.985 271 190 268.985 190 266.5L190 245.5C190 243.015 187.985 241 185.5 241L134.5 241C132.015 241 130 243.015 130 245.5L130 267.605C130 268.505 129.642 269.369 129.006 270.006C128.369 270.642 127.505 271 126.605 271L104.5 271C102.015 271 100 273.015 100 275.5L100 296.5C100 298.985 102.015 301 104.5 301L125.5 301C127.985 301 130 298.985 130 296.5L130 274.395C130 273.494 130.358 272.631 130.994 271.994C131.631 271.358 132.494 271 133.395 271L185.5 271Z",
    fill: "url(#paint1_linear_1_169)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1311 273C1314.31 273 1317 275.686 1317 279V307C1317 310.314 1314.31 313 1311 313H1283C1279.69 313 1277 310.314 1277 307L1277 279C1277 275.686 1279.69 273 1283 273L1311 273Z",
    fill: "url(#paint2_linear_1_169)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M450 25C453.314 25 456 27.6863 456 31V59C456 62.3137 453.314 65 450 65H422C418.686 65 416 62.3137 416 59L416 31C416 27.6863 418.686 25 422 25L450 25Z",
    fill: "url(#paint3_linear_1_169)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.4 5C109.493 5 112 7.50721 112 10.6V36.7333C112 39.8261 109.493 42.3333 106.4 42.3333H66.028C64.5428 42.3333 63.1184 42.9233 62.0682 43.9735L61.3735 44.6682C60.3233 45.7184 59.7333 47.1428 59.7333 48.628V72.4539C59.7333 73.9392 60.3233 75.3635 61.3735 76.4137L62.9863 78.0265C64.0365 79.0767 65.4608 79.6667 66.9461 79.6667H106.4C109.493 79.6667 112 82.1739 112 85.2667V111.4C112 114.493 109.493 117 106.4 117H65.3333C62.2405 117 59.7333 114.493 59.7333 111.4V84.8332C59.7333 83.4629 59.189 82.1488 58.2201 81.1799C57.2512 80.211 55.9371 79.6667 54.5668 79.6667H5.6C2.50721 79.6667 0 77.1595 0 74.0667V47.9333C0 44.8405 2.50721 42.3333 5.6 42.3333L53.4692 42.3333C54.9544 42.3333 56.3788 41.7433 57.429 40.6931L58.0931 40.029C59.1433 38.9788 59.7333 37.5544 59.7333 36.0692V10.6C59.7333 7.50721 62.2405 5 65.3333 5H106.4Z",
    fill: "url(#paint4_linear_1_169)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1326.37 38.7145C1327.19 39.5378 1328.31 40.0004 1329.47 40.0004H1360.61C1363.03 40.0004 1365 41.966 1365 44.3907V75.6104C1365 78.0351 1363.03 80.0007 1360.61 80.0007L1329.05 80.0007C1327.98 80.0007 1326.95 80.4277 1326.19 81.1879C1325.43 81.948 1325 82.979 1325 84.054V115.611C1325 118.035 1323.04 120.001 1320.61 120.001H1289.39C1286.97 120.001 1285 118.035 1285 115.611V84.4721C1285 83.3077 1284.54 82.191 1283.72 81.3677L1283.63 81.2866C1282.81 80.4632 1281.69 80.0007 1280.53 80.0007H1249.39C1246.97 80.0007 1245 78.0351 1245 75.6104V44.3906C1245 41.966 1246.97 40.0004 1249.39 40.0004H1280.25C1281.42 40.0004 1282.53 39.5378 1283.36 38.7145L1283.72 38.3565C1284.54 37.5332 1285 36.4165 1285 35.2521V4.39028C1285 1.96559 1286.97 0 1289.39 0H1320.61C1323.04 0 1325 1.9656 1325 4.39028V35.5304C1325 36.6947 1325.46 37.8114 1326.29 38.6348L1326.37 38.7145ZM1323.64 41.2862C1322.81 40.4629 1321.7 40.0003 1320.53 40.0003H1289.05C1287.98 40.0003 1286.95 40.4274 1286.19 41.1876C1285.43 41.9479 1285 42.9789 1285 44.0541V75.5308C1285 76.6951 1285.46 77.8118 1286.29 78.6352L1286.37 78.7148C1287.19 79.5381 1288.31 80.0007 1289.47 80.0007L1320.25 80.0007C1321.42 80.0007 1322.54 79.5382 1323.36 78.7148L1323.71 78.3595C1324.54 77.5362 1325 76.4195 1325 75.2551V44.4688C1325 43.3045 1324.54 42.1878 1323.71 41.3644L1323.64 41.2862Z",
    fill: "url(#paint5_linear_1_169)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.45 566.901C1287.74 567.604 1286.79 567.999 1285.8 567.999L1173.75 567.999C1171.68 567.999 1170 569.678 1170 571.749L1170 604.249C1170 606.32 1171.68 607.999 1173.75 607.999L1285.52 607.999C1286.51 607.999 1287.47 608.394 1288.17 609.097L1288.9 609.83C1289.61 610.534 1290 611.487 1290 612.482L1290 643.796C1290 644.79 1289.61 645.744 1288.9 646.448L1288.45 646.902C1287.75 647.605 1286.79 648 1285.8 648L1253.75 648C1251.68 648 1250 649.679 1250 651.75L1250 684.25C1250 686.321 1251.68 688 1253.75 688L1286.25 688C1288.32 688 1290 686.321 1290 684.25L1290 652.206C1290 651.211 1290.4 650.257 1291.1 649.554L1291.56 649.098C1292.26 648.395 1293.21 648 1294.21 648L1326.25 648C1328.32 648 1330 646.321 1330 644.25L1330 612.206C1330 611.211 1330.4 610.257 1331.1 609.554L1331.56 609.098C1332.26 608.395 1333.21 608 1334.21 608L1366.25 608C1368.32 608 1370 606.321 1370 604.25L1370 571.75C1370 569.679 1368.32 568 1366.25 568L1333.93 568C1332.93 568 1331.98 567.605 1331.28 566.902L1331.1 566.723C1330.4 566.02 1330 565.066 1330 564.071L1330 531.749C1330 529.678 1328.32 527.999 1326.25 527.999L1293.93 527.999C1292.93 527.999 1291.98 527.604 1291.28 526.901L1291.1 526.724C1290.4 526.02 1290 525.067 1290 524.072L1290 491.75C1290 489.679 1288.32 488 1286.25 488L1253.75 488C1251.68 488 1250 489.679 1250 491.75L1250 524.25C1250 526.321 1251.68 528 1253.75 528L1285.52 528C1286.51 528 1287.47 528.395 1288.17 529.098L1288.9 529.83C1289.6 530.533 1290 531.487 1290 532.481L1290 563.795C1290 564.79 1289.6 565.743 1288.9 566.447L1288.45 566.901ZM1291.1 569.553C1290.4 570.257 1290 571.21 1290 572.205L1290 604.071C1290 605.066 1290.4 606.02 1291.1 606.723L1291.28 606.902C1291.98 607.605 1292.93 608 1293.93 608L1325.8 608C1326.79 608 1327.75 607.605 1328.45 606.902L1328.9 606.448C1329.61 605.744 1330 604.79 1330 603.796L1330 572.482C1330 571.488 1329.61 570.534 1328.9 569.83L1328.17 569.097C1327.47 568.394 1326.51 567.999 1325.52 567.999L1294.21 567.999C1293.21 567.999 1292.26 568.394 1291.55 569.097L1291.1 569.553Z",
    fill: "url(#paint6_linear_1_169)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1131.19 205.187C1131.95 204.427 1132.98 204 1134.05 204H1165.61C1168.03 204 1170 202.034 1170 199.609V168.39C1170 165.966 1168.03 164 1165.61 164H1134.39C1131.97 164 1130 165.966 1130 168.39V199.251C1130 200.416 1129.54 201.532 1128.71 202.356L1128.36 202.714C1127.53 203.537 1126.42 204 1125.25 204H1094.39C1091.97 204 1090 205.965 1090 208.39V239.609C1090 242.034 1091.97 243.999 1094.39 243.999H1125.61C1128.03 243.999 1130 242.034 1130 239.609V208.053C1130 206.978 1130.43 205.947 1131.19 205.187Z",
    fill: "url(#paint7_linear_1_169)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M327.187 664.813C326.427 664.052 326 663.021 326 661.946L326 630.39C326 627.965 324.034 626 321.609 626L290.39 626C287.966 626 286 627.965 286 630.39L286 661.609C286 664.033 287.966 665.999 290.39 665.999L321.251 665.999C322.416 665.999 323.532 666.462 324.356 667.285L324.714 667.643C325.537 668.466 326 669.583 326 670.747L326 701.609C326 704.034 327.965 706 330.39 706L361.609 706C364.034 706 365.999 704.034 365.999 701.609L365.999 670.39C365.999 667.966 364.034 666 361.609 666L330.053 666C328.978 666 327.947 665.573 327.187 664.813Z",
    fill: "url(#paint8_linear_1_169)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114.187 529.187C114.947 528.427 115.978 528 117.053 528H148.61C151.034 528 153 526.034 153 523.609V492.39C153 489.966 151.034 488 148.61 488H117.391C114.966 488 113 489.966 113 492.39V523.251C113 524.416 112.538 525.532 111.715 526.356L111.357 526.714C110.533 527.537 109.417 528 108.252 528H77.3902C74.9656 528 73 529.965 73 532.39V563.609C73 566.034 74.9656 567.999 77.3902 567.999H108.609C111.034 567.999 113 566.034 113 563.609V532.053C113 530.978 113.427 529.947 114.187 529.187Z",
    fill: "url(#paint9_linear_1_169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_169",
    x1: 160,
    y1: 301,
    x2: 160,
    y2: 181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_169",
    x1: 160,
    y1: 301,
    x2: 160,
    y2: 181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_169",
    x1: 1297,
    y1: 273,
    x2: 1297,
    y2: 313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_169",
    x1: 436,
    y1: 25,
    x2: 436,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_169",
    x1: 56,
    y1: 4.99999,
    x2: 56,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_169",
    x1: 1305,
    y1: -0.00000998683,
    x2: 1305,
    y2: 120.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_169",
    x1: 1170,
    y1: 588,
    x2: 1370,
    y2: 588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_169",
    x1: 1130,
    y1: 164,
    x2: 1130,
    y2: 243.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_169",
    x1: 286,
    y1: 666,
    x2: 365.999,
    y2: 666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_169",
    x1: 113,
    y1: 488,
    x2: 113,
    y2: 567.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.d2f8fff9818eff32997c4fa0848e38f8.svg";
export { ForwardRef as ReactComponent };